type Brand = {
  name: string;
  domain: string;
  /** Tailwind utilities for the text fallback if the logo image fails to load. */
  fallbackCls: string;
};

const brands: Brand[] = [
  { name: "Anker", domain: "anker.com", fallbackCls: "font-semibold tracking-tight" },
  { name: "HexClad", domain: "hexclad.com", fallbackCls: "font-bold tracking-[0.1em] text-sm" },
  { name: "OLIPOP", domain: "drinkolipop.com", fallbackCls: "font-bold tracking-[0.2em] text-sm" },
  { name: "Magic Spoon", domain: "magicspoon.com", fallbackCls: "font-medium tracking-tight italic" },
  { name: "Liquid I.V.", domain: "liquid-iv.com", fallbackCls: "font-semibold tracking-tight" },
  { name: "native", domain: "nativecos.com", fallbackCls: "font-light tracking-[0.15em] text-sm" },
  { name: "TRUFF", domain: "truff.com", fallbackCls: "font-bold tracking-[0.25em] text-sm" },
  { name: "Caraway", domain: "carawayhome.com", fallbackCls: "font-medium tracking-tight" },
];

export function LogoWall() {
  return (
    <section className="border-y border-slate-200 bg-slate-50/50 dark:border-slate-800 dark:bg-slate-900/50">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <p className="text-xs font-semibold tracking-[0.2em] text-slate-500 dark:text-slate-400">
          BUILT FOR AMAZON BRANDS LIKE
        </p>
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-px bg-slate-200 rounded-xl overflow-hidden ring-1 ring-slate-200 dark:bg-slate-800 dark:ring-slate-800">
          {brands.map((b) => (
            <BrandCell key={b.name} brand={b} />
          ))}
        </div>
        <p className="mt-4 text-[10px] leading-relaxed text-slate-400 dark:text-slate-500">
          All brand names and logos shown are trademarks of their respective
          owners. Inclusion is illustrative of Reputely&rsquo;s target market
          and does not imply endorsement, sponsorship, or a customer
          relationship.
        </p>
      </div>
    </section>
  );
}

function BrandCell({ brand }: { brand: Brand }) {
  return (
    <div className="flex h-20 items-center justify-center bg-slate-50/80 px-4 text-slate-500 dark:bg-slate-900/80 dark:text-slate-400">
      <img
        src={`https://logo.clearbit.com/${brand.domain}?size=128`}
        alt={`${brand.name} logo`}
        loading="lazy"
        className="max-h-8 max-w-[80%] object-contain opacity-80 grayscale transition hover:opacity-100 hover:grayscale-0"
        onError={(e) => {
          const img = e.currentTarget;
          img.style.display = "none";
          const sibling = img.nextElementSibling as HTMLElement | null;
          if (sibling) sibling.style.display = "inline";
        }}
      />
      <span
        className={brand.fallbackCls}
        style={{ display: "none" }}
        aria-hidden="true"
      >
        {brand.name}
      </span>
    </div>
  );
}
